<template>
  <div
      class="position-relative w-100 h-100"
      :class="bgLayoutMap[props.effectMode]"
      :style="{
        maxWidth:`${defaultWidth}px`,
        maxHeight:`${defaultHeight}px`
      }"
  >
    <div class="text_wrap overflow-hidden"
         :class="[
             horizontalPosition[textLayoutData.arr[0].HorizontalAlignment],
             verticalPosition[textLayoutData.arr[0].VerticalAlignment],
            { 'center': textLayoutData.arr[0].HorizontalAlignment === 'Center' && textLayoutData.arr[0].VerticalAlignment === 'Center' },
            wrapCustomMap[props.effectMode]
            ]"
         :style="{
            textShadow: `3px 3px 10px rgba(0,0,0, ${textShadow})`,
            opacity: `${textOpacity}`,
            padding: handleGetPaddingFix(props.effectMode, textLayoutData.arr[0].FontSize),
            maxHeight: handleGetMaxHeight(props.effectMode, textLayoutData.arr[0].FontSize)
           }"
    >
      <template v-if="typeof customTextContent === 'object' && customTextContent.length > 0">
        <div
            class="w-100"
            :class="[
                textAlign[textLayoutData.arr[0].TextAlignment],
                mainFontFamily
                ]"
            :style="{
              'wordBreak': 'break-word',
              'color': changeToRgba(textLayoutData.arr[0].FontColors[0]),
              'fontSize': textLayoutData.arr[0].FontSize ? `${textLayoutData.arr[0].FontSize}px`: '43px',
              'lineHeight': handleGetLineHeightFix(props.effectMode, textLayoutData.arr[0].FontSize),
              'letterSpacing': handleGetLetterSpacingFix(props.effectMode, textLayoutData.arr[0].FontSize)
            }"
            v-for="(text, i) in customTextContent"
            :key="i"
        >
          {{ text }}
        </div>
      </template>
      <template v-else>
        <div
            class="w-100"
            :class="[
                textAlign[textLayoutData.arr[0].TextAlignment],
                mainFontFamily
                ]"
            :style="{
              'wordBreak': 'break-word',
              'color': changeToRgba(textLayoutData.arr[0].FontColors[0]),
              'fontSize': textLayoutData.arr[0].FontSize ? `${textLayoutData.arr[0].FontSize}px`: '43px',
              'lineHeight': handleGetLineHeightFix(props.effectMode, textLayoutData.arr[0].FontSize),
              'letterSpacing': handleGetLetterSpacingFix(props.effectMode, textLayoutData.arr[0].FontSize)
            }"
        >
          {{ customTextContent }}
        </div>
      </template>
    </div>
  </div>
</template>
<script setup>
import defaultValue from "@/utils/defaultValue";

import {ref, reactive, watchEffect} from 'vue'
import changeToRgba from '@/utils/globalFunc'
import textModeTool from "@/utils/textModeTool";

const {defaultWidth, defaultHeight} = defaultValue()

const {
  bgLayoutMap,
  horizontalPosition,
  verticalPosition,
  initMainFontFamily
} = textModeTool()

const props = defineProps(["textData", 'effectMode', 'controlMode'])
const texts = reactive(props.textData)
const textLayoutData = reactive({arr: []})
const controllerLoopSecond = ref(0)
const customTextContent = ref([])
const mainFontFamily = ref('')

const textShadow = ref('35%')
const textOpacity = ref('100%')

const wrapCustomMap = {
  'none': '',
  'Rain3D': 'wrap_custom_large', // 下雨
  'Snow3d': 'wrap_custom_large', // 下雨
  'Snow': 'wrap_custom_large', // 下雪
  'Fireworks': 'wrap_custom_large', // 煙火
  'MeteorShower': 'wrap_custom_large', // 流星雨
  'Image': 'wrap_custom_large',
  'Color': 'wrap_custom_large',
  'TwistHole': 'wrap_custom_small',
  'TimeTunnel': 'wrap_custom_small',
  'Mandala': 'wrap_custom_small',
  'Blossom': 'wrap_custom_small',
  'Kaleidoscope': 'wrap_custom_small' ,
  'RainbowShoot': 'wrap_custom_small',
  'Swirl': 'wrap_custom_small',
  'TransformSpot': 'wrap_custom_small'
}

const textAlign = reactive({
  Left: "text-start",
  Center: "text-center",
  Right: "text-end"
})


// const customLineHeightMap = {
//   '25': '29px', // 行距 29px, 中心型 小
//   '43': '58px', // 行距 58px
//   '65': '77px', // 行距 77px
//   '75': '78px', // 中心型 大
//   '42': '48px', // 中心型 中
//   '35': '42px', // 中心型 中
// }

const handleGetLetterSpacingFix = (effectMode, fz) => {
  switch (effectMode) {
    case 'Blossom':
      switch (fz) {
        case 42:
          return '2px'
      }
      break
    // case 'Swirl':
    //   switch (fz) {
    //     case 25:
    //       return '29px'
    //     case 42:
    //       return '45px'
    //     case 75:
    //       return '78px'
    //   }
    //   break
    // case 'RainbowShoot':
    //   switch (fz) {
    //     case 25:
    //       return '29px'
    //     case 42:
    //       return '45px'
    //     case 75:
    //       return '78px'
    //   }
    //   break
    default: return 'initial'
  }
}

const handleGetLineHeightFix = (effectMode, fz) => {
  switch (effectMode) {
    case 'TwistHole':
      switch (fz) {
        case 25:
          return '29px'
        case 42:
          return '48px'
        case 75:
          return '78px'
      }
      break
    case 'Kaleidoscope':
      switch (fz) {
        case 25:
          return '29px'
        case 35:
          return '42px'
        case 75:
          return '78px'
      }
      break
    case 'Mandala':
      switch (fz) {
        case 25:
          return '30px'
        case 42:
          return '44px'
        case 75:
          return '78px'
      }
      break
    case 'Blossom':
      switch (fz) {
        case 28:
          return '35px'
        case 42:
          return '50px'
        case 75:
          return '78px'
      }
      break
    case 'TransformSpot':
      switch (fz) {
        case 28:
          return '33px'
        case 48:
          return '53px'
        case 75:
          return '78px'
      }
      break
    case 'TimeTunnel':
      switch (fz) {
        case 25:
          return '31px'
        case 35:
          return '43px'
        case 75:
          return '78px'
      }
      break
    case 'Swirl':
      switch (fz) {
        case 25:
          return '35px'
        case 42:
          return '47px'
        case 75:
          return '78px'
      }
      break
    case 'RainbowShoot':
      switch (fz) {
        case 25:
          return '35px'
        case 42:
          return '47px'
        case 75:
          return '77px'
      }
      break
    default:
      switch (fz) {
        case 25:
          return '29px'
        case 43:
          return '58px'
        case 65:
          return '77px'
      }
  }
}

const handleGetPaddingFix = (effectMode, fz) => {
  switch (effectMode) {
    case 'TwistHole':
      switch (fz) {
        case 75: return '0 0 20px 0'
        default: return '0'
      }
    case 'Mandala':
      switch (fz) {
        case 75: return '4px 0 0'
        default: return '0'
      }
    case 'Swirl':
      switch (fz) {
        case 25: return '0 0 10px'
        case 42: return '0 0 11px'
        case 75: return '0 0 10px'
        default: return '0'
      }
    case 'RainbowShoot':
      switch (fz) {
        case 25: return '0 0 7px'
        case 75: return '0 0 20px'
        default: return '0'
      }
  }
  return '0'
}


const handleGetMaxHeight = (effectMode, fz) => {
  switch (effectMode) {
    case 'TwistHole':
      switch (fz) {
        case 25:
          return '145px' // 29*5
        case 42:
          return '144px' // 48*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'Kaleidoscope':
      switch (fz) {
        case 25:
          return '145px' // 29*5
        case 35:
          return '126px' // 42*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'Mandala':
      switch (fz) {
        case 25:
          return '150px' // 30*5
        case 42:
          return '132px' // 44*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'Blossom':
      switch (fz) {
        case 28:
          return '175px' // 35*5
        case 42:
          return '150px' // 50*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'TransformSpot':
      switch (fz) {
        case 28:
          return '198px' // 33*6
        case 48:
          return '159px' // 53*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'TimeTunnel':
      switch (fz) {
        case 25:
          return '155px' // 31*5
        case 35:
          return '129px' // 43*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'Swirl':
      switch (fz) {
        case 25:
          return '175px' // 35*5
        case 42:
          return '141px' // 47*3
        case 75:
          return '156px' // 78*2
      }
      break
    case 'RainbowShoot':
      switch (fz) {
        case 25:
          return '175px' // 35*5
        case 42:
          return '141px' // 47*3
        case 75:
          return '154px' // 77*2
      }
      break
    default:
      return 'initial'
      // switch (fz) {
      //   case 25:
      //     return '29px'
      //   case 43:
      //     return '58px'
      //   case 65:
      //     return '77px'
      // }
  }
}

watchEffect(() => {
  const {
    Type,
    Layout,
    Text: customText,
  } = texts


  if (Type === 'None' || Type === undefined) {
    textLayoutData.arr = []
    return false
  }

  // 取得文字對齊位置
  Object.assign(textLayoutData.arr, Layout)

  const {
    Shadow,
    Opacity,
    FontFamily
  } = Layout[0]
  textShadow.value = parseInt(Shadow) >= 0 ? `${Shadow}%` : '35%'
  textOpacity.value = parseInt(Opacity) >= 0 ? `${Opacity}%` : '100%'
  if (FontFamily && FontFamily !== '') mainFontFamily.value = `font_family_${FontFamily}`
  else mainFontFamily.value = initMainFontFamily(props.effectMode)

  if (props.controlMode && props.controlMode.toString() === 'true') {
    if (customText && customText.length > 0) customTextContent.value = customText.filter(item => item !== '')
  } else {
    if (customText.indexOf('\n') >= 0 ) {
      const customTextArr = customText.split('\n')
      customTextContent.value = customTextArr.filter(item => item !== '')
    } else customTextContent.value = customText
  }

})
</script>
